// NPM Imports
import React, { Fragment } from "react";

// Internal Imports
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "../../../revvComponents";

// Component Imports
import { UpgradeBadge } from "../../../commonComponents";

export default function ContentLockUpgrade(props) {
  return (
    <Fragment>
      <Tooltip
        placement="top"
        overlay="Lock this block"
        align={{ offset: [0, 3] }}>
        <span
          className="btn-icon"
          data-test="documentitems-lock-the-content-btn"
          id="lock-the-content-btn"
          onMouseDown={() =>
            props.toggleUpgradePopup("showContentLockUpgradePopup", true)
          }
          onKeyPress={() => {}}
          role="button"
          tabIndex={0}>
          <FontAwesomeIcon icon={["far", "unlock"]} />
          <span className="contentlockupgrade-badge">
            <UpgradeBadge isPro />
          </span>
        </span>
      </Tooltip>
    </Fragment>
  );
}
